export function useEscassezReference() {
  const findLayerRecursive = (items, targetId) => {
    if (!items) return null;

    for (const item of items) {
      if (item.id == targetId) {
        return item;
      }

      if (item.layers && item.layers.length > 0) {
        const found = findLayerRecursive(item.layers, targetId);
        if (found) return found;
      }
    }
    return null;
  };

  const fetchEscassezReference = async (layers, layerId) => {
    if (!layers) return;

    const layerEscassez = findLayerRecursive(layers, layerId);
    if (!layerEscassez) return;

    let baseUrl = layerEscassez.url.replace('wms', 'wfs');
    if (baseUrl.includes('?')) {
      baseUrl = baseUrl.split('?')[0];
    }

    const layerName = layerEscassez.url_params.LAYERS;

    const params = new URLSearchParams({
      service: 'WFS',
      version: '1.0.0',
      request: 'GetFeature',
      typeName: layerName,
      maxFeatures: '1',
      outputFormat: 'application/json',
      propertyName: 'ehdreferencia'
    });

    try {
      const response = await fetch(`${baseUrl}?${params.toString()}`);
      const data = await response.json();

      if (data.features && data.features.length > 0) {
        const ref = data.features[0].properties.ehdreferencia;
        const formatedDate = ref.substring(0, 7).split('-').reverse().join('/');

        if (layerEscassez.caption_html && layerEscassez.caption_html.groupItems) {
          const groupExist = layerEscassez.caption_html.groupItems.find(g => g.isDynamicRefGroup);

          if (groupExist) {
            if (groupExist.items && groupExist.items.length > 0) {
              groupExist.items[0].text = formatedDate;
            }
          } else {
            layerEscassez.caption_html.groupItems.push({
              text: "Data de referência",
              isDynamicRefGroup: true,
              items: [
                {
                  text: formatedDate,
                  color: 'transparent',
                  style: 'square'
                }
              ]
            });
          }
        }
      }
    } catch (error) {
      console.error("Erro ao buscar referência WFS:", error);
    }
  };

  return {
    fetchEscassezReference,
    findLayerRecursive
  };
}